import localforage from 'localforage';

export type OfflineActionType = 'CREATE_ORDER' | 'CREATE_VISIT' | 'UPDATE_ORDER' | 'UPDATE_VISIT';

export interface OfflineAction {
  id: string;
  type: OfflineActionType;
  payload: unknown;
  timestamp: number;
  url?: string;
  method?: 'POST' | 'PUT';
}

class OfflineQueueService {
  private store: LocalForage;

  constructor() {
    this.store = localforage.createInstance({
      name: 'ERP_OfflineQueue',
      storeName: 'actions',
    });
  }

  async enqueueAction(
    type: OfflineActionType,
    payload: unknown,
    url?: string,
    method: 'POST' | 'PUT' = 'POST',
  ): Promise<string> {
    const id = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const action: OfflineAction = {
      id,
      type,
      payload,
      timestamp: Date.now(),
      url,
      method,
    };
    await this.store.setItem(id, action);
    return id;
  }

  async getQueue(): Promise<OfflineAction[]> {
    const queue: OfflineAction[] = [];
    await this.store.iterate((value: OfflineAction) => {
      queue.push(value);
    });
    // Sort oldest first
    return queue.sort((a, b) => a.timestamp - b.timestamp);
  }

  async removeFromQueue(id: string): Promise<void> {
    await this.store.removeItem(id);
  }

  async clearQueue(): Promise<void> {
    await this.store.clear();
  }
}

export const offlineQueueService = new OfflineQueueService();
